// extracted by mini-css-extract-plugin
export default {"card":"c-e_eh","card_styleDefault":"c-e_ei","card_styleRed":"c-e_ej"};